import Trainer from './Trainer.jsx'

export default Trainer